import React from 'react';
import { Box, Typography } from '@mui/material';

function SummaryCard({ label, value, highlight }) {
  return (
    <Box sx={{
      flex: 1,
      minWidth: 160,
      backgroundColor: 'background.paper',
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 2,
      px: 2.5,
      py: 2,
    }}>
      <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mb: 0.5 }}>
        {label}
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: 700, color: highlight ? 'error.main' : 'text.primary' }}>
        {value}
      </Typography>
    </Box>
  );
}

function AttendanceSummaryBar({ totalMinutes, totalSalary, totalPaid, remaining, lifetimeRemaining }) {
  const hours = Math.floor(totalMinutes / 60);
  const mins  = Math.round(totalMinutes % 60);

  const fmt = (n) => n.toLocaleString('pl-PL', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' zł';

  return (
    <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap', justifyContent: 'center' }}>
      <SummaryCard label="Łączne godziny"      value={`${hours}h ${mins}m`} />
      <SummaryCard label="Zarobili"      value={fmt(totalSalary)} />
      <SummaryCard label="Wypłacone zaliczki"   value={fmt(totalPaid)} />
      <SummaryCard label="Pozostało do wypłaty" value={fmt(remaining)} highlight={remaining > 0} />
      {lifetimeRemaining !== undefined && (
        <SummaryCard label="Suma do wypłaty (wszystkie okresy)" value={fmt(lifetimeRemaining)} highlight={lifetimeRemaining > 0} />
      )}
    </Box>

  );
}

export default AttendanceSummaryBar;
